<template>
  <v-card class="pa-4" :class="{ 'error-scroller': error }">
    <p class="title mb-1">Lojas selecionadas</p>
    <slot name="additional-content"></slot>
    <template>
      <v-row class="mt-3 pa-0">
        <v-col v-if="!(units && units.length)" cols="2">
          <v-progress-circular class="loader" indeterminate color="primary" />
        </v-col>
        <v-col v-else>
          <v-chip-group show-arrows active-class="primary--text" :column="showAllUnits">
            <template v-if="disable">
              <v-chip v-for="(unit, index) in unitsSelectedName" :key="`${unit.name}-${index}`" small class="disabled-chip" disabled>
                <span
                  ><strong class="pr-2">{{ unit.name }}</strong></span
                >
              </v-chip>
            </template>
            <template v-else>
              <v-chip v-for="(unit, index) in unitsSelectedName" :key="`${unit.name}-${index}`" small class="disabled-chip" :ripple="false">
                <span
                  ><strong class="pr-2">{{ unit.name }}</strong></span
                >
              </v-chip>
            </template>
          </v-chip-group>
        </v-col>
      </v-row>
      <div v-if="!disable">
        <a v-if="localSelectedUnits && localSelectedUnits.length" class="user-select-none mt-0 mb-2 body-2" @click="showAllUnits = !showAllUnits">{{
          showAllUnits ? 'Minimizar' : 'Mostrar todos'
        }}</a>
      </div>
      <div style="margin-top: 10px !important">
        <mf-select-units-dialog
          template-type="button"
          required
          select-all-units-on-init
          label="Lojas"
          hide-ecommerce-configuration
          :disable-save="disable"
          :disabled="disabled"
          :selected-units.sync="localSelectedUnits"
          :units="units"
          :tag-list="tagList"
          :group-list="unitsGroups"
        />
      </div>
      <p v-if="error" class="error--text my-2">Você deve selecionar ao menos uma Loja.</p>
    </template>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    error: Boolean,
    disable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selectedUnits: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    showAllUnits: false,
    unitError: false,
  }),
  computed: {
    ...mapGetters(['units', 'tagList', 'unitsGroups']),
    unitsSelectedName() {
      return this.units.filter((unit) => this.localSelectedUnits.includes(unit.id_erp))
    },
    localSelectedUnits: {
      get() {
        return this.selectedUnits
      },
      set(value) {
        this.$emit('update:selectedUnits', value)
      },
    },
  },
}
</script>
